// extracted by mini-css-extract-plugin
export var hasTextWeightBold = "index-module--has-text-weight-bold--a45ec";
export var hasTextWeightLight = "index-module--has-text-weight-light--6b00d";
export var isUppercase = "index-module--is-uppercase--db237";
export var richText = "index-module--richText--388a9";
export var wrapper = "index-module--wrapper--edf90";